import React from 'react'
import { useHistory } from 'react-router-dom'

import EventList from './list'
import { PageHeader, Avatar, Space, Badge, Collapse, Divider, Result } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import { useFetch, useDismiss } from '../../../../hooks/manager/event'

import Loader from '../../../../components/loader'

/*
import { Gantt } from 'gantt-task-react'
import 'gantt-task-react/dist/index.css'

export const GanttView = (props) => {
  const goBack = () => props.history.goBack()
  const { past, present, future } = props.data

  const completeList = [ ...past, ...present, ...future ]
  const tasks = (completeList || []).map(item => {
    return ({
      start: new Date(item.date_from),
      end: new Date(item.date_to),
      name: item.vendor ? item.vendor.name : (item.manager ? item.manager.name : '?'),
      id: item.id,
      type: 'task',
      isDisabled: false,
      styles: { progressColor: '#ffbb54', progressSelectedColor: '#ff9e0d' }
    })
  })

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <PageHeader ghost={false} onBack={goBack} title={<>Events</>}>
        {(past || []).length === 0 && (present || []).length === 0 && (future || []).length == 0 && (
          <Result icon={<BellOutlined />} title='There are no active events.' />
        )}
      </PageHeader>
      <div style={{backgroundColor: '#fff' }}>
        <Gantt tasks={tasks} />
      </div>
    </Space>
  )
}
*/

const EventIcon = require('../../../../assets/icons/event.png')

const { Panel } = Collapse

const PanelTitle = (props) => (
  <>
    <Avatar src={props?.icon} shape='square' />
    <Divider type='vertical' />
    {props?.text}
  </>
)

const View = (props) => {
  const history = useHistory()
  const goBack = () => history.goBack()
  const { data, isLoading, isError } = useFetch()
  const { mutate: dismissEvent, isLoading: isDismissLoading } = useDismiss()

  const createBadge = (num) => <Badge count={num} showZero />

  if (isLoading) {
    return (<Loader loading />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const { past, present, future } = data

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <PageHeader ghost={false} onBack={goBack} title={<>Events</>}>
        {(past || []).length === 0 && (present || []).length === 0 && (future || []).length === 0 && (
          <Result icon={<BellOutlined />} title='There are no active events.' />
        )}
      </PageHeader>

      {(past || []).length > 0 && (
        <Collapse expandIconPosition='right' defaultActiveKey={['panel-1']}>
          <Panel
            key='panel-1'
            header={<PanelTitle text='Past events' icon={EventIcon} />}
            extra={createBadge((past || []).length)}
            className='custom-collpase-panel'
          >
            <EventList list={past || []} onDismissEvent={dismissEvent} isDismissLoading={isDismissLoading} />
          </Panel>
        </Collapse>
      )}
      {(present || []).length > 0 && (
        <Collapse expandIconPosition='right' defaultActiveKey={['panel-1']}>
          <Panel
            key='panel-1'
            header={<PanelTitle text='Current events' icon={EventIcon} />}
            extra={createBadge((present || []).length)}
            className='custom-collpase-panel'
          >
            <EventList list={present || []} onDismissEvent={dismissEvent} isDismissLoading={isDismissLoading} />
          </Panel>
        </Collapse>
      )}
      {(future || []).length > 0 && (
        <Collapse expandIconPosition='right' defaultActiveKey={['panel-1']}>
          <Panel
            key='panel-1'
            header={<PanelTitle text='Future events' icon={EventIcon} />}
            extra={createBadge((future || []).length)}
            className='custom-collpase-panel'
          >
            <EventList list={future || []} onDismissEvent={dismissEvent} isDismissLoading={isDismissLoading} />
          </Panel>
        </Collapse>
      )}
    </Space>
  )
}

export default View
